import React, { useState } from 'react';
import '../pages/styles.css';

// The lightweight "Er du sikker?" confirmation used across the app for
// routine (but irreversible) actions — removing a user, clearing notes.
// For genuinely severe deletions (a whole tenant or organization) use
// ConfirmDeleteModal instead, which adds a type-the-name speed bump.
export default function ConfirmDialog({ title, message, confirmLabel = 'Bekræft', danger = true, onConfirm, onCancel }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function handleConfirm() {
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      await onConfirm();
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  }

  return (
    <div className="modal-overlay" onClick={() => !busy && onCancel()}>
      <div className="modal-panel modal-panel--compact" onClick={(e) => e.stopPropagation()}>
        <div className="modal-panel__head">
          <h2>{title}</h2>
          <button className="modal-panel__close" onClick={onCancel} aria-label="Luk" disabled={busy}>×</button>
        </div>
        <div className="modal-panel__body">
          <p className="modal-section__hint" style={{ margin: 0 }}>{message}</p>
          {error && <p className="modal-msg modal-msg--error">{error}</p>}
          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onCancel} disabled={busy}>Annullér</button>
            <button type="button" className={danger ? 'btn-delete' : 'btn-primary'} onClick={handleConfirm} disabled={busy}>
              {busy ? 'Vent…' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
